import { memoize } from 'lodash-es'

import {
  CartFulfillment,
  CartFulfillmentKinds,
  CartFulfillmentTable,
  CartFulfillmentPickup,
  CartFulfillmentDelivery,
  CartFulfillmentDropOff,
  CartFulfillmentScheduleTypes,
  CartFulfillmentShipping,
  Cart,
  CartItemTypes,
} from 'Types'

export const isTable = memoize(
  (fulfillment: CartFulfillment | null): fulfillment is CartFulfillmentTable =>
    fulfillment?.kind === CartFulfillmentKinds.TABLESIDE,
)

export const isPickup = memoize(
  (fulfillment: CartFulfillment | null): fulfillment is CartFulfillmentPickup =>
    fulfillment?.kind === CartFulfillmentKinds.PICKUP,
)

export const isDelivery = memoize(
  (fulfillment: CartFulfillment | null): fulfillment is CartFulfillmentDelivery =>
    fulfillment?.kind === CartFulfillmentKinds.DELIVERY,
)

export const isDropOff = memoize(
  (fulfillment: CartFulfillment | null): fulfillment is CartFulfillmentDropOff =>
    fulfillment?.kind === CartFulfillmentKinds.DROP_OFF,
)

export const isShipping = memoize(
  (fulfillment: CartFulfillment | null): fulfillment is CartFulfillmentShipping =>
    fulfillment?.kind === CartFulfillmentKinds.SHIPPING,
)

export const isASAP = memoize(
  (
    fulfillment: CartFulfillment | null,
  ): fulfillment is CartFulfillment & { scheduleType: CartFulfillmentScheduleTypes.ASAP } =>
    fulfillment?.scheduleType === CartFulfillmentScheduleTypes.ASAP,
)

export const someMenuItems = (cart: Cart): boolean =>
  cart.cartItems.some((cartItem) => cartItem.type === CartItemTypes.MENU_ITEMABLE)
